import { GridColumnConfig } from "../../../models/gridCoumnConfig";

export const fileProcessingColumns: GridColumnConfig[] = [
  {
    title: 'Work Order#',
    field: 'workOrderNumber',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    searchable: true,
    width: '220px'
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    searchable: true,
    width: '220px'
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    searchable: true,
    width: '220px'
  },
  {
    title: 'Jobsite',
    field: 'jobSite',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'Lot#',
    field: 'unitName',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    searchable: true,
    width: '220px'
  },
  {
    title: 'Assigned To',
    field: 'assignee',
    filter: 'text',
    searchable: true,
    width: '230px'
  },
  {
    title: 'Service Type',
    field: 'serviceGroupName',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'Status',
    field: 'planReviewTaskStatus',
    filter: 'text',
    searchable: true,
    width: '160px'
  },
  {
    title: 'Reg. #',
    field: 'registrationNumber',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
  {
    title: 'Final Scheduled On',
    field: 'finalScheduledDate',
    filter: 'text',
    searchable: true,
    width: '180px'
  },
];
